import { TFunction } from 'i18next'

import { RecipeStatus } from 'src/api/requests'

export const getRecipeStatus = (t: TFunction, status?: RecipeStatus) => {
  const statusMap = {
    [RecipeStatus.NEW]: {
      color: 'gold',
      text: t('consultations.new_recipe')
    },
    [RecipeStatus.DECLINED]: {
      color: 'red',
      text: t('consultations.refused_recipe')
    },
    [RecipeStatus.DISPENSED]: {
      color: 'green',
      text: t('consultations.dispensed_recipe')
    },
    [RecipeStatus.CANCELLED]: {
      color: 'red',
      text: t('consultations.cancelled_recipe')
    }
  }

  return {
    color: status ? statusMap[status].color : 'defaultColor',
    text: status ? statusMap[status].text : t('stock_applications.unknown')
  }
}
